import { combineReducers } from 'redux';

import { reducer as oneTimeDetails } from './oneTimeDetailsModule';

export default combineReducers({
	oneTimeDetails,
});
